import { useSearchParams } from 'react-router-dom';
import React, { useState } from 'react';
import { Grid, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavBarContainer, NavBarTitle } from 'common/NavBar';
import { useGetSchedulesQuery } from 'store/schedules/schedules';
import WorkScheduleList from 'components/WorkScheduleList/WorkScheduleList';
import emptyApiResponse from 'store/emptyApiResponse';
import usePagination from 'hooks/usePagination';
import CustomPagination from 'common/CustomPagination/CustomPagination';
import EmptyWorkScheduleList from 'components/EmptyWorkScheduleList/EmptyWorkScheduleList';
import AddButton from 'common/AddButton/AddButton';
import AddWorkSchedule from 'components/AddWorkSchedule/AddWorkSchedule';

export default function WorkSchedules() {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams({});
  const { page, handleOnPageChange, handleOnItemsPerPageChange, itemsPerPage } =
    usePagination({
      searchParams,
      setSearchParams,
    });
  const {
    data: schedulesData = { 'hydra:member': [], ...emptyApiResponse },
    isFetching: schedulesFetching,
    isError: schedulesError,
  } = useGetSchedulesQuery({
    page,
    itemsPerPage,
  });

  const noWorkSchedule =
    schedulesData['hydra:member'].length && !schedulesFetching;
  const shouldDisplayPagination = !!schedulesData['hydra:view']?.['hydra:last'];

  return (
    <>
      <Grid item xs={10} bgcolor="background.list">
        <NavBarContainer>
          <NavBarTitle>{t('settings.work_schedules')}</NavBarTitle>
          <AddButton
            onClick={() => setIsAddModalOpen(true)}
            label="project_tracking.add_work_schedule"
          />
        </NavBarContainer>
        <Stack p={3}>
          <WorkScheduleList
            schedules={schedulesData['hydra:member']}
            schedulesError={schedulesError}
            schedulesFetching={schedulesFetching}
            isPaginationDisplayed={shouldDisplayPagination}
          />
          {!noWorkSchedule && (
            <EmptyWorkScheduleList onClick={() => setIsAddModalOpen(true)} />
          )}
          {shouldDisplayPagination && (
            <CustomPagination
              apiData={schedulesData}
              itemsPerPage={itemsPerPage}
              page={page}
              handleOnPageChange={handleOnPageChange}
              handleOnItemsPerPageChange={handleOnItemsPerPageChange}
              showRowsSelect={false}
            />
          )}
        </Stack>
      </Grid>
      <AddWorkSchedule
        onClose={() => setIsAddModalOpen(false)}
        isModalOpen={isAddModalOpen}
      />
    </>
  );
}
